if (!customElements.get('mopale-calendar-thanks')) {
  customElements.define('mopale-calendar-thanks', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const landingUrl = new URL(location.href);
      const fromSignup = landingUrl.hash === '#contact_form' || landingUrl.searchParams.has('customer_posted') || landingUrl.searchParams.has('contact_posted');
      if (fromSignup) {
        landingUrl.hash = '';
        landingUrl.searchParams.delete('customer_posted');
        landingUrl.searchParams.delete('contact_posted');
        history.replaceState(history.state, '', landingUrl);
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      }
      this.grid = this.querySelector('[data-products]');
      this.status = this.querySelector('[data-status]');
      this.loadButton = this.querySelector('[data-load]');
      this.sentinel = this.querySelector('[data-sentinel]');
      this.dialog = this.querySelector('dialog');
      const dismissSignupPopup = () => {
        document.querySelector('[aria-labelledby="trustoo-popup-optIn-title"] .ecomsend__Modal__CloseButton')?.click();
      };
      this.popupObserver = new MutationObserver(dismissSignupPopup);
      this.popupObserver.observe(document.body, { childList: true, subtree: true });
      dismissSignupPopup();
      this.nextPage = 1;
      this.buffer = [];
      this.seen = new Set();
      this.shown = 0;
      this.busy = false;
      this.finished = false;
      this.loadButton.hidden = false;
      this.loadButton.addEventListener('click', () => this.load());
      const menuButton = this.querySelector('[data-menu-open]');
      menuButton.hidden = false;
      menuButton.addEventListener('click', () => this.dialog.showModal());
      this.dialog.addEventListener('close', () => menuButton.focus({ preventScroll: true }));
      this.querySelector('[data-menu-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) this.load();
        }, { rootMargin: '300px' });
      }
      this.load();
    }

    disconnectedCallback() {
      this.popupObserver?.disconnect();
      this.observer?.disconnect();
      this.controller?.abort();
      this.initialized = false;
    }

    async fetchBatch() {
      const url = new URL(this.dataset.collectionUrl, location.origin);
      url.searchParams.set('sort_by', 'manual');
      url.searchParams.set('section_id', 'mopale-thanks-products');
      url.searchParams.set('page', String(this.nextPage));
      const previewTheme = new URL(location.href).searchParams.get('preview_theme_id');
      if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
      this.controller = new AbortController();
      const timeout = setTimeout(() => this.controller.abort(), 15000);
      try {
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) throw new Error('Product feed unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const feed = doc.querySelector('[data-thanks-feed]');
        if (!feed || Number(feed.dataset.page) !== this.nextPage || feed.dataset.sort !== 'manual') throw new Error('Unexpected product feed');
        const next = feed.dataset.nextPage ? Number(feed.dataset.nextPage) : null;
        if (next !== null && (!Number.isInteger(next) || next <= this.nextPage)) throw new Error('Invalid pagination');
        const cards = [...feed.querySelectorAll('[data-product-id]')];
        for (const card of cards) {
          if (this.seen.has(card.dataset.productId)) continue;
          this.seen.add(card.dataset.productId);
          this.buffer.push(card);
        }
        this.nextPage = next;
      } finally {
        clearTimeout(timeout);
      }
    }

    async load() {
      if (this.busy || this.finished || !this.isConnected) return;
      this.busy = true;
      this.observer?.unobserve(this.sentinel);
      this.loadButton.disabled = true;
      this.grid.setAttribute('aria-busy', 'true');
      this.status.textContent = this.dataset.loading;
      const target = Math.min(12, 50 - this.shown);
      try {
        while (this.buffer.length < target && this.nextPage !== null) {
          await this.fetchBatch();
          if (!this.isConnected) return;
        }
        const cards = this.buffer.splice(0, target);
        this.grid.append(...cards);
        this.shown += cards.length;
        this.finished = this.shown >= 50 || (this.nextPage === null && this.buffer.length === 0);
        this.status.textContent = this.shown ? this.dataset.count.replace('__COUNT__', String(this.shown)) : this.dataset.empty;
        this.loadButton.hidden = this.finished;
        if (!this.finished) this.observer?.observe(this.sentinel);
      } catch (error) {
        if (this.isConnected) {
          this.status.textContent = this.dataset.error;
          this.loadButton.hidden = false;
        }
      } finally {
        this.busy = false;
        this.loadButton.disabled = false;
        this.grid.setAttribute('aria-busy', 'false');
      }
    }
  });
}
